import React from 'react';
import { Card, Statistic } from 'antd';
import styled from 'styled-components';

const StyledCard = styled(Card)<{ clickable?: boolean }>`
  height: 100%;
  cursor: ${props => props.clickable ? 'pointer' : 'default'};
  transition: all 0.3s ease;

  .ant-card-body {
    padding: 24px;
  }
  .ant-statistic-title {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    margin-bottom: 8px;
  }
  .ant-statistic-content {
    font-size: 30px;
    font-weight: 600;
  }

  ${props => props.clickable && `
    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
    }
  `}
`;

const TrendText = styled.span<{ positive?: boolean }>`
  font-size: 14px;
  color: ${props => props.positive ? '#52c41a' : '#8c8c8c'};
  margin-left: 8px;
`;

interface StatsCardProps {
  title: string;
  value: number | string;
  suffix?: string;
  prefix?: string;
  trend?: string;
  trendPositive?: boolean;
  loading?: boolean;
  onClick?: () => void;
}

const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  suffix,
  prefix,
  trend,
  trendPositive,
  loading = false,
  onClick
}) => {
  return (
    <StyledCard
      bordered={false}
      loading={loading}
      clickable={!!onClick}
      onClick={onClick}
    >
      <Statistic
        title={title}
        value={value}
        suffix={suffix}
        prefix={prefix}
      />
      {trend && (
        <TrendText positive={trendPositive}>{trend}</TrendText>
      )}
    </StyledCard>
  );
};

export default StatsCard;
